import { gql } from '@apollo/client'
import { type DataProvider } from 'react-admin'
import { apolloClient } from '@shared/api/apolloClient'

export const englishLevelProvider: DataProvider = {
  getList: async (resource, params) => {
    return await apolloClient
      .query({
        query: gql`
          query {
            getLevels {
              id
              title
            }
          }
        `
      })
      .then((result) => ({
        data: result.data.getLevels,
        pageInfo: {
          hasNextPage: false,
          hasPreviousPage: false
        }
      }))
  },
  getOne: async (resource, { id }) => ({
    data: { id } as any
  }),
  getMany: async () => ({
    data: [] as any
  }),
  getManyReference: async () => ({
    data: [] as any,
    pageInfo: {
      hasNextPage: false,
      hasPreviousPage: false
    }
  }),
  create: async () => ({
    data: [] as any
  }),
  update: async () => ({
    data: [] as any
  }),
  updateMany: async () => ({
    data: [] as any
  }),
  delete: async () => ({
    data: [] as any
  }),
  deleteMany: async () => ({
    data: [] as any
  })
}
